export default __webpack_public_path__ + "static/media/dark_placeholder.7c4f5095.jpg";